var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Messages = void 0;
var TabLoc = __importStar(require("../gen-src/Localize"));
var localization_1 = require("./localizationUtils/localization");
exports.Messages = {
    commentingTitle: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('commentingTitle'), a) : TabLoc.Messages.commentingTitle(a);
    },
    commentingNotFoundErrorMessage: function () {
        return localization_1.messageMap ? localization_1.getMessage('commentingNotFoundErrorMessage') : TabLoc.Messages.commentingNotFoundErrorMessage();
    },
    menuMarkAsUnread: function () {
        return localization_1.messageMap ? localization_1.getMessage('menuMarkAsUnread') : TabLoc.Messages.menuMarkAsUnread();
    },
    menuMarkAsRead: function () {
        return localization_1.messageMap ? localization_1.getMessage('menuMarkAsRead') : TabLoc.Messages.menuMarkAsRead();
    },
    menuRemoveNotification: function () {
        return localization_1.messageMap ? localization_1.getMessage('menuRemoveNotification') : TabLoc.Messages.menuRemoveNotification();
    },
    extractDataSourceNotFoundErrorMessage: function () {
        return localization_1.messageMap ? localization_1.getMessage('extractDataSourceNotFoundErrorMessage') : TabLoc.Messages.extractDataSourceNotFoundErrorMessage();
    },
    extractWorkbookNotFoundErrorMessage: function () {
        return localization_1.messageMap ? localization_1.getMessage('extractWorkbookNotFoundErrorMessage') : TabLoc.Messages.extractWorkbookNotFoundErrorMessage();
    },
    extractFailureMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractFailureMessage'), a) : TabLoc.Messages.extractFailureMessage(a);
    },
    extractFailureTime: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractFailureTime'), a) : TabLoc.Messages.extractFailureTime(a);
    },
    extractDataSourceMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractDataSourceMessage'), a) : TabLoc.Messages.extractDataSourceMessage(a);
    },
    extractDataSourceWithLinkMessage: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractDataSourceWithLinkMessage'), a)
            : TabLoc.Messages.extractDataSourceWithLinkMessage(a);
    },
    extractLastRefreshMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractLastRefreshMessage'), a) : TabLoc.Messages.extractLastRefreshMessage(a);
    },
    extractResolutionMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractResolutionMessage'), a) : TabLoc.Messages.extractResolutionMessage(a);
    },
    extractCreateFailureExtractCreationDatasource: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractCreateFailureExtractCreationDatasource'), a)
            : TabLoc.Messages.extractCreateFailureExtractCreationDatasource(a);
    },
    extractCreateFailureExtractCreationWithName: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractCreateFailureExtractCreationWithName'), a)
            : TabLoc.Messages.extractCreateFailureExtractCreationWithName(a);
    },
    extractCreateFailureExtractCreationWithNameNoLink: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractCreateFailureExtractCreationWithNameNoLink'), a)
            : TabLoc.Messages.extractCreateFailureExtractCreationWithNameNoLink(a);
    },
    extractCreateFailureExtractCreationWorkbooksWithCount: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractCreateFailureExtractCreationWorkbooksWithCount'), a)
            : TabLoc.Messages.extractCreateFailureExtractCreationWorkbooksWithCount(a);
    },
    extractFailureOutOfDateWithName: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('extractFailureOutOfDateWithName'), a) : TabLoc.Messages.extractFailureOutOfDateWithName(a);
    },
    extractFailureOutOfDateWithNameNoLink: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('extractFailureOutOfDateWithNameNoLink'), a)
            : TabLoc.Messages.extractFailureOutOfDateWithNameNoLink(a);
    },
    failureExtractCreationWorkbooksWithCount: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('failureExtractCreationWorkbooksWithCount'), a)
            : TabLoc.Messages.failureExtractCreationWorkbooksWithCount(a);
    },
    outOfDateWorkbookNone: function () {
        return localization_1.messageMap ? localization_1.getMessage('outOfDateWorkbookNone') : TabLoc.Messages.outOfDateWorkbookNone();
    },
    extractCreationFailed: function () {
        return localization_1.messageMap ? localization_1.getMessage('extractCreationFailed') : TabLoc.Messages.extractCreationFailed();
    },
    tableRefreshFailed: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableRefreshFailed') : TabLoc.Messages.tableRefreshFailed();
    },
    tableSuspendedType: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableSuspendedType') : TabLoc.Messages.tableSuspendedType();
    },
    tableWarningType: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableWarningType') : TabLoc.Messages.tableWarningType();
    },
    tableFailureType: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableFailureType') : TabLoc.Messages.tableFailureType();
    },
    lastRunSuccess: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('lastRunSuccess'), a) : TabLoc.Messages.lastRunSuccess(a);
    },
    never: function () {
        return localization_1.messageMap ? localization_1.getMessage('never') : TabLoc.Messages.never();
    },
    tableAlertCreated: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableAlertCreated') : TabLoc.Messages.tableAlertCreated();
    },
    failureNote: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('failureNote'), a) : TabLoc.Messages.failureNote(a);
    },
    signInFailedUnknownReason: function () {
        return localization_1.messageMap ? localization_1.getMessage('signInFailedUnknownReason') : TabLoc.Messages.signInFailedUnknownReason();
    },
    expiredPassword: function () {
        return localization_1.messageMap ? localization_1.getMessage('expiredPassword') : TabLoc.Messages.expiredPassword();
    },
    accessTokenValidation: function () {
        return localization_1.messageMap ? localization_1.getMessage('accessTokenValidation') : TabLoc.Messages.accessTokenValidation();
    },
    authConfiguration: function () {
        return localization_1.messageMap ? localization_1.getMessage('authConfiguration') : TabLoc.Messages.authConfiguration();
    },
    connectionFailure: function () {
        return localization_1.messageMap ? localization_1.getMessage('connectionFailure') : TabLoc.Messages.connectionFailure();
    },
    invalidFilePath: function () {
        return localization_1.messageMap ? localization_1.getMessage('invalidFilePath') : TabLoc.Messages.invalidFilePath();
    },
    overlappingSchedules: function () {
        return localization_1.messageMap ? localization_1.getMessage('overlappingSchedules') : TabLoc.Messages.overlappingSchedules();
    },
    fullRefreshRequired: function () {
        return localization_1.messageMap ? localization_1.getMessage('fullRefreshRequired') : TabLoc.Messages.fullRefreshRequired();
    },
    tableNotFound: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableNotFound') : TabLoc.Messages.tableNotFound();
    },
    unknownColumn: function () {
        return localization_1.messageMap ? localization_1.getMessage('unknownColumn') : TabLoc.Messages.unknownColumn();
    },
    queryCompilationError: function () {
        return localization_1.messageMap ? localization_1.getMessage('queryCompilationError') : TabLoc.Messages.queryCompilationError();
    },
    federatedError: function () {
        return localization_1.messageMap ? localization_1.getMessage('federatedError') : TabLoc.Messages.federatedError();
    },
    invalidSemiStructDataSchema: function () {
        return localization_1.messageMap ? localization_1.getMessage('invalidSemiStructDataSchema') : TabLoc.Messages.invalidSemiStructDataSchema();
    },
    unableToConnectToFile: function () {
        return localization_1.messageMap ? localization_1.getMessage('unableToConnectToFile') : TabLoc.Messages.unableToConnectToFile();
    },
    noDriver: function () {
        return localization_1.messageMap ? localization_1.getMessage('noDriver') : TabLoc.Messages.noDriver();
    },
    incompatibleDocumentVersion: function () {
        return localization_1.messageMap ? localization_1.getMessage('incompatibleDocumentVersion') : TabLoc.Messages.incompatibleDocumentVersion();
    },
    extractRefreshNotFinishedOnTime: function () {
        return localization_1.messageMap ? localization_1.getMessage('extractRefreshNotFinishedOnTime') : TabLoc.Messages.extractRefreshNotFinishedOnTime();
    },
    embedded: function () {
        return localization_1.messageMap ? localization_1.getMessage('embedded') : TabLoc.Messages.embedded();
    },
    bridgeClientNotRunning: function () {
        return localization_1.messageMap ? localization_1.getMessage('bridgeClientNotRunning') : TabLoc.Messages.bridgeClientNotRunning();
    },
    unknownFailure: function () {
        return localization_1.messageMap ? localization_1.getMessage('unknownFailure') : TabLoc.Messages.unknownFailure();
    },
    signInFailedUnknownReasonResolutionDetails: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('signInFailedUnknownReasonResolutionDetails')
            : TabLoc.Messages.signInFailedUnknownReasonResolutionDetails();
    },
    dataConnectionResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('dataConnectionResolutionDetails') : TabLoc.Messages.dataConnectionResolutionDetails();
    },
    invalidFilePathResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('invalidFilePathResolutionDetails') : TabLoc.Messages.invalidFilePathResolutionDetails();
    },
    invalidFilePathResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('invalidFilePathResolutionDetailsRemote') : TabLoc.Messages.invalidFilePathResolutionDetailsRemote();
    },
    overlappingSchedulesResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('overlappingSchedulesResolutionDetails') : TabLoc.Messages.overlappingSchedulesResolutionDetails();
    },
    fullRefreshRequiredResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('fullRefreshRequiredResolutionDetails') : TabLoc.Messages.fullRefreshRequiredResolutionDetails();
    },
    connectionlessFailureResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('connectionlessFailureResolutionDetails') : TabLoc.Messages.connectionlessFailureResolutionDetails();
    },
    invalidSemiStructDataSchemaResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('invalidSemiStructDataSchemaResolutionDetailsRemote')
            : TabLoc.Messages.invalidSemiStructDataSchemaResolutionDetailsRemote();
    },
    unableToConnectToFileResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('unableToConnectToFileResolutionDetailsRemote')
            : TabLoc.Messages.unableToConnectToFileResolutionDetailsRemote();
    },
    unknownColumnResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('unknownColumnResolutionDetailsRemote') : TabLoc.Messages.unknownColumnResolutionDetailsRemote();
    },
    federatedErrorResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('federatedErrorResolutionDetailsRemote') : TabLoc.Messages.federatedErrorResolutionDetailsRemote();
    },
    queryCompilationErrorResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('queryCompilationErrorResolutionDetailsRemote')
            : TabLoc.Messages.queryCompilationErrorResolutionDetailsRemote();
    },
    tableNotFoundResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('tableNotFoundResolutionDetailsRemote') : TabLoc.Messages.tableNotFoundResolutionDetailsRemote();
    },
    noDriverResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('noDriverResolutionDetailsRemote') : TabLoc.Messages.noDriverResolutionDetailsRemote();
    },
    incompatibleDocumentVersionResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('incompatibleDocumentVersionResolutionDetailsRemote')
            : TabLoc.Messages.incompatibleDocumentVersionResolutionDetailsRemote();
    },
    wdcAbortErrorResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('wdcAbortErrorResolutionDetailsRemote') : TabLoc.Messages.wdcAbortErrorResolutionDetailsRemote();
    },
    wdcInvalidDataResolutionDetailsRemote: function () {
        return localization_1.messageMap ? localization_1.getMessage('wdcInvalidDataResolutionDetailsRemote') : TabLoc.Messages.wdcInvalidDataResolutionDetailsRemote();
    },
    extractRefreshNotFinishedOnTimeResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('extractRefreshNotFinishedOnTimeResolutionDetailsRemote')
            : TabLoc.Messages.extractRefreshNotFinishedOnTimeResolutionDetailsRemote();
    },
    bridgeClientNotRunningResolutionDetailsRemote: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('bridgeClientNotRunningResolutionDetailsRemote')
            : TabLoc.Messages.bridgeClientNotRunningResolutionDetailsRemote();
    },
    unknownFailureResolutionDetails: function () {
        return localization_1.messageMap ? localization_1.getMessage('unknownFailureResolutionDetails') : TabLoc.Messages.unknownFailureResolutionDetails();
    },
    outOfDateWorkbooksWithCount: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('outOfDateWorkbooksWithCount'), a) : TabLoc.Messages.outOfDateWorkbooksWithCount(a);
    },
    flowSuspensionMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('flowSuspensionMessage'), a) : TabLoc.Messages.flowSuspensionMessage(a);
    },
    flowFailedWithErrorsCount: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('flowFailedWithErrorsCount'), a) : TabLoc.Messages.flowFailedWithErrorsCount(a);
    },
    flowSuspensionStatusWithCount: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('flowSuspensionStatusWithCount'), a) : TabLoc.Messages.flowSuspensionStatusWithCount(a);
    },
    flowErrorMessage: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('flowErrorMessage'), a) : TabLoc.Messages.flowErrorMessage(a);
    },
    flowNotFoundMessage: function () {
        return localization_1.messageMap ? localization_1.getMessage('flowNotFoundMessage') : TabLoc.Messages.flowNotFoundMessage();
    },
    errorFlowInsufficientPermissions: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowInsufficientPermissions') : TabLoc.Messages.errorFlowInsufficientPermissions();
    },
    errorFlowNotFound: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowNotFound'), a) : TabLoc.Messages.errorFlowNotFound(a);
    },
    errorFlowNameAlreadyExists: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowNameAlreadyExists') : TabLoc.Messages.errorFlowNameAlreadyExists();
    },
    errorFlowDestinationProjectNotFound: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowDestinationProjectNotFound') : TabLoc.Messages.errorFlowDestinationProjectNotFound();
    },
    errorFlowDescriptionTooLong: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowDescriptionTooLong'), a) : TabLoc.Messages.errorFlowDescriptionTooLong(a);
    },
    errorFlowJobBulked: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowJobBulked') : TabLoc.Messages.errorFlowJobBulked();
    },
    errorUnknown: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorUnknown') : TabLoc.Messages.errorUnknown();
    },
    errorFlowRunUnknown: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunUnknown') : TabLoc.Messages.errorFlowRunUnknown();
    },
    errorFlowRunExecution: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunExecution') : TabLoc.Messages.errorFlowRunExecution();
    },
    errorFlowRunNodeExecution: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunNodeExecution'), a) : TabLoc.Messages.errorFlowRunNodeExecution(a);
    },
    errorFlowRunUnsupportedDocumentFeature: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunUnsupportedDocumentFeature') : TabLoc.Messages.errorFlowRunUnsupportedDocumentFeature();
    },
    errorFlowRunInputConnectivity: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunInputConnectivity'), a) : TabLoc.Messages.errorFlowRunInputConnectivity(a);
    },
    errorFlowRunOutputConnectivity: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunOutputConnectivity'), a) : TabLoc.Messages.errorFlowRunOutputConnectivity(a);
    },
    errorFlowRunPublishingOutput: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunPublishingOutput'), a) : TabLoc.Messages.errorFlowRunPublishingOutput(a);
    },
    errorFlowRunInvalidUsernameOrPassword: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunInvalidUsernameOrPassword') : TabLoc.Messages.errorFlowRunInvalidUsernameOrPassword();
    },
    errorFlowRunInputDriver: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunInputDriver') : TabLoc.Messages.errorFlowRunInputDriver();
    },
    errorFlowRunUnapprovedRead: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunUnapprovedRead') : TabLoc.Messages.errorFlowRunUnapprovedRead();
    },
    errorFlowRunUnapprovedWrite: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunUnapprovedWrite') : TabLoc.Messages.errorFlowRunUnapprovedWrite();
    },
    errorFlowRunLoomCompilation: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunLoomCompilation') : TabLoc.Messages.errorFlowRunLoomCompilation();
    },
    errorFlowRunNodeCompilation: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunNodeCompilation'), a) : TabLoc.Messages.errorFlowRunNodeCompilation(a);
    },
    errorFlowRunNodeExpression: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunNodeExpression'), a) : TabLoc.Messages.errorFlowRunNodeExpression(a);
    },
    errorFlowRunTimeout: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunTimeout') : TabLoc.Messages.errorFlowRunTimeout();
    },
    errorFlowRunPermission: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunPermission') : TabLoc.Messages.errorFlowRunPermission();
    },
    errorFlowRunWriteToDBDisabled: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('errorFlowRunWriteToDBDisabled'), a) : TabLoc.Messages.errorFlowRunWriteToDBDisabled(a);
    },
    errorFlowRunWriteToDBWindowsAuth: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunWriteToDBWindowsAuth'), a)
            : TabLoc.Messages.errorFlowRunWriteToDBWindowsAuth(a);
    },
    errorFlowRunWriteToTdeIsDeprecating: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunWriteToTdeIsDeprecating') : TabLoc.Messages.errorFlowRunWriteToTdeIsDeprecating();
    },
    errorFlowRunFailedToConnectExternalResourceError: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunFailedToConnectExternalResourceError'), a)
            : TabLoc.Messages.errorFlowRunFailedToConnectExternalResourceError(a);
    },
    errorFlowRunMissingConnectionInformation: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunMissingConnectionInformation'), a)
            : TabLoc.Messages.errorFlowRunMissingConnectionInformation(a);
    },
    errorFlowRunCannotConnectInputDatasource: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunCannotConnectInputDatasource'), a)
            : TabLoc.Messages.errorFlowRunCannotConnectInputDatasource(a);
    },
    errorFlowRunInputDatasourceMissingDBName: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunInputDatasourceMissingDBName'), a)
            : TabLoc.Messages.errorFlowRunInputDatasourceMissingDBName(a);
    },
    errorFlowRunInputDatasourceHasUserReference: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('errorFlowRunInputDatasourceHasUserReference')
            : TabLoc.Messages.errorFlowRunInputDatasourceHasUserReference();
    },
    errorFlowRunPublishOutputMissingURL: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunPublishOutputMissingURL'), a)
            : TabLoc.Messages.errorFlowRunPublishOutputMissingURL(a);
    },
    errorFlowRunPublishProjectNotFound: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunPublishProjectNotFound') : TabLoc.Messages.errorFlowRunPublishProjectNotFound();
    },
    errorFlowRunPublishFailedPermissionDenied: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('errorFlowRunPublishFailedPermissionDenied')
            : TabLoc.Messages.errorFlowRunPublishFailedPermissionDenied();
    },
    errorFlowRunPublishDatasourceFailed: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunPublishDatasourceFailed'), a)
            : TabLoc.Messages.errorFlowRunPublishDatasourceFailed(a);
    },
    errorFlowRunPublishDataRoleFailed: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunPublishDataRoleFailed'), a)
            : TabLoc.Messages.errorFlowRunPublishDataRoleFailed(a);
    },
    errorFlowRunGeneralPublishingError: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('errorFlowRunPublishFailedPermissionDenied')
            : TabLoc.Messages.errorFlowRunPublishFailedPermissionDenied();
    },
    errorFlowRunOutputsLocationConflict: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunOutputsLocationConflict'), a)
            : TabLoc.Messages.errorFlowRunOutputsLocationConflict(a);
    },
    errorFlowRunOutputLocationConflictWithInput: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunOutputLocationConflictWithInput'), a)
            : TabLoc.Messages.errorFlowRunOutputLocationConflictWithInput(a);
    },
    errorFlowRunCancelledDueToLimits: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunCancelledDueToLimits') : TabLoc.Messages.errorFlowRunCancelledDueToLimits();
    },
    errorFlowRunCannotWriteToDatabase: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunCannotWriteToDatabase') : TabLoc.Messages.errorFlowRunCannotWriteToDatabase();
    },
    errorFlowRunMissingTableNameForWriteToDatabase: function () {
        return localization_1.messageMap
            ? localization_1.getMessage('errorFlowRunMissingTableNameForWriteToDatabase')
            : TabLoc.Messages.errorFlowRunMissingTableNameForWriteToDatabase();
    },
    errorFlowRunVizportalAuthenticationError: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunVizportalAuthenticationError') : TabLoc.Messages.errorFlowRunVizportalAuthenticationError();
    },
    errorFlowRunIncrementalRefreshOutputMustRunTogether: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunIncrementalRefreshOutputMustRunTogether'), a)
            : TabLoc.Messages.errorFlowRunIncrementalRefreshOutputMustRunTogether(a);
    },
    errorFlowRunIncrementalRefreshOutputMustRunInSameMode: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunIncrementalRefreshOutputMustRunInSameMode'), a)
            : TabLoc.Messages.errorFlowRunIncrementalRefreshOutputMustRunInSameMode(a);
    },
    errorFlowRunIncrementalRefreshFilterIsNull: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunIncrementalRefreshFilterIsNull'), a)
            : TabLoc.Messages.errorFlowRunIncrementalRefreshFilterIsNull(a);
    },
    errorFlowRunIncrementalRefreshFailed: function (a) {
        return localization_1.messageMap
            ? localization_1.formatString(localization_1.getMessage('errorFlowRunIncrementalRefreshFailed'), a)
            : TabLoc.Messages.errorFlowRunIncrementalRefreshFailed(a);
    },
    errorFlowRunWriteOptionNotSpecified: function () {
        return localization_1.messageMap ? localization_1.getMessage('errorFlowRunWriteOptionNotSpecified') : TabLoc.Messages.errorFlowRunWriteOptionNotSpecified();
    },
    sharingTitle: function (a) {
        return localization_1.messageMap ? localization_1.formatString(localization_1.getMessage('sharingTitle'), a) : TabLoc.Messages.sharingTitle(a);
    },
    workbookLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('workbookLowerCase') : TabLoc.Messages.workbookLowerCase();
    },
    viewLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('viewLowerCase') : TabLoc.Messages.viewLowerCase();
    },
    customViewLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('customViewLowerCase') : TabLoc.Messages.customViewLowerCase();
    },
    datasourceLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('datasourceLowerCase') : TabLoc.Messages.datasourceLowerCase();
    },
    flowLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('flowLowerCase') : TabLoc.Messages.flowLowerCase();
    },
    projectLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('projectLowerCase') : TabLoc.Messages.projectLowerCase();
    },
    dataConnectionLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('dataConnectionLowerCase') : TabLoc.Messages.dataConnectionLowerCase();
    },
    metricLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('metricLowerCase') : TabLoc.Messages.metricLowerCase();
    },
    publishedConnectionLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('publishedConnectionLowerCase') : TabLoc.Messages.publishedConnectionLowerCase();
    },
    collectionLowerCase: function () {
        return localization_1.messageMap ? localization_1.getMessage('collectionLowerCase') : TabLoc.Messages.collectionLowerCase();
    },
    userRemoved: function () {
        return localization_1.messageMap ? localization_1.getMessage('userRemoved') : TabLoc.Messages.userRemoved();
    },
};
//# sourceMappingURL=messages.js.map